<template>
    <nav id="top-rail">
        <div class="nav-bg">
            <slot>
                <label for="hamburger" class="material-icons icon-toggle">menu</label>
                <input type="checkbox" id="hamburger" v-model="menuOpen" />
                <div id="logo-mobile" @click="hideBurger()">
                    <router-link to="/"><img src="@/images/logo.svg" style="width: 82px; height: 24px" /></router-link>
                </div>
                <div @click="hideBurger()" id="mobile-menu">
                    <router-link to="/" class="mobile-only" exact-path>Dashboard</router-link>
                    <router-link to="/tracklist" class="mobile-only menu-divide" exact-path>My TrackList</router-link>
                    <router-link to="/companies" v-if="hasReadPermission" exact-path>Companies</router-link>
                    <router-link to="/executives" v-if="hasReadPermission" exact-path>Executives</router-link>
                    <router-link to="/premium-research-reports" exact-path>Premium Research</router-link>
                    <router-link to="/evasion" class="menu-divide" v-if="hasReadPermission" exact-path
                        >Evasion</router-link
                    >
                    <router-link to="/account#Profile" class="mobile-only" exact-path>Account Profile</router-link>
                    <router-link to="/manage/" class="mobile-only" v-if="manage" exact-path>Manage</router-link>
                    <router-link to="/admin/organizations" class="mobile-only" v-if="manage" exact-path
                        >Organizations</router-link
                    >
                    <router-link to="/admin/users" v-if="isSalesAdmin" class="menu-divide mobile-only" exact-path>
                        Users
                    </router-link>
                    <a href="#" @click.prevent="logout" class="account-menu-divider mobile-only">Logout</a>
                </div>
                <div class="search-section" v-if="hasReadPermission">
                    <MtSearch
                        @viewAll="viewAllSearchResults"
                        :search-text.sync="searchText"
                        :searchTypes="searchEntityTypes"
                    >
                        <template #placeholder v-if="showSearchPlaceholder">
                            <div class="search-placeholder">
                                <img src="@/images/search-graphic.svg" />
                                <div>Use the search above to find Executives, Companies & Interviews</div>
                            </div>
                        </template>
                    </MtSearch>
                </div>
                <button
                    id="order-custom-work-header"
                    class="primary"
                    @click.stop.prevent="showCustomWorkModal"
                    style="width: auto"
                >
                    Order Custom Work
                </button>
            </slot>
        </div>
    </nav>
</template>
<script>
import { hasAnyEditRole, hasReadRole, hasSalesAdminRole } from '@/utils/jwt.js'
import AuthenticationService from '@/services/authenticationService'

import MtSearch from '@/components/Search/mt-search.vue'

export default {
    components: {
        MtSearch,
    },
    data() {
        return {
            menuOpen: false,
        }
    },
    computed: {
        hasReadPermission() {
            return hasReadRole()
        },
        isSalesAdmin() {
            return hasSalesAdminRole()
        },
        watchlist() {
            return this.$store.getters.watchlist.watchlists[0]
        },
        hasWatchlistMembers() {
            const executives = this.watchlist?.executives || []
            const companies = this.watchlist?.companies || []

            return executives.length > 0 || companies.length > 0
        },
        searchText: {
            get() {
                return this.$store.getters.searchModal.search
            },
            set(value) {
                this.$store.getters.searchModal.search = value
            },
        },
        searchEntityTypes() {
            return null
        },
        showSearchPlaceholder() {
            return this.$route.path === '/' && !this.hasWatchlistMembers
        },
        manage() {
            return hasAnyEditRole()
        },
    },
    methods: {
        hideBurger() {
            this.menuOpen = false
        },
        async logout() {
            const { ok } = await AuthenticationService.logout()

            if (ok) {
                this.$router.push('/login')
            }
        },
        showCustomWorkModal() {
            this.$store.getters.customWork.show()
        },
        viewAllSearchResults(searchText, tab) {
            this.$store.getters.searchModal.open = true
            this.$store.getters.searchModal.search = searchText
            this.$store.getters.searchModal.tab = tab
        },
    },
}
</script>
<style>
#top-rail {
    --top-rail-mobile-height: calc(var(--top-rail-height) - var(--top-rail-border-width));
    display: flex;
    align-items: flex-start;
    background-image: var(--border-image);
    height: var(--top-rail-height);
    width: 100%;

    white-space: nowrap;

    .search-dropdown {
        min-width: 640px;
    }

    label,
    #hamburger {
        display: none;
    }

    #mobile-menu {
        color: var(--color-light-text);
    }

    .search-section {
        max-width: 960px;
        width: 40%;

        div.search-placeholder {
            align-items: center;
            display: flex;
            padding: 16px 0;
            width: 100%;
            white-space: normal;

            img {
                height: 96px;
            }

            div {
                flex-grow: 1;
                font-size: 24px;
                font-weight: 700;
                color: #0f0b18;
                margin-bottom: 8px;
            }
        }
    }
    .mobile-only {
        display: none;
    }
    .nav-bg {
        align-items: center;
        background-color: var(--color-dark-background);
        display: flex;
        gap: 40px;
        padding: 0 24px;
        height: var(--top-rail-mobile-height);
        vertical-align: middle;
        width: 100%;
    }

    #mobile-menu {
        display: flex;
        gap: 24px;
        flex-grow: 1;

        font-size: var(--font-size-nav-text);
        font-weight: var(--weight-semibold);
        &:first-child {
            margin-left: 40px;
        }

        img {
            height: 16px;
        }
    }
}

@media screen and (max-width: 1000px) {
    #top-rail {
        #order-custom-work-header {
            display: none;
        }
    }
}

/* [ON SMALL SCREENS] */
@media screen and (max-width: 768px) {
    /* Show Hamburger */
    #top-rail {
        background-image: var(--border-image);
        background: #000;
        height: var(--top-rail-mobile-height);

        .nav-bg {
            gap: 24px;
        }

        label {
            display: inline-block;
            color: #fff;
            background-color: #333;
            font-style: normal;
            font-size: 2em;
            padding: 8px;
        }

        .mobile-only {
            display: initial;
        }

        #logo-mobile {
            flex-grow: 1;
        }

        /* Toggle show/hide menu on checkbox click */
        #mobile-menu {
            display: none;
            flex-direction: column;
            background-color: #fff;
            left: 0;
            margin: 0;
            top: var(--top-rail-mobile-height);
            width: 100dvw;
            height: calc(100dvh - var(--top-rail-mobile-height));
            overflow: hidden;
            position: absolute;
            padding: 24px;
            z-index: var(--z-index-menu);

            > * {
                display: block;
                padding-bottom: 24px;
                overflow: hidden;
                color: #333;
                width: 100%;
            }
        }

        input:checked ~ #mobile-menu {
            display: flex;
        }
        .menu-divide {
            border-bottom: 1px solid var(--color-alpha-1);
        }

        .search-section {
            flex-grow: 1;
            max-width: unset;

            .search-input-absolute {
                min-width: unset;
                right: -24px;
                width: 100dvw;
            }

            .search-dropdown {
                min-width: unset;
                width: 100%;
            }
        }
    }
}
@media screen and (max-width: 420px) {
    #top-rail {
        ul {
            li {
                display: block;
                padding: 16px;
            }
        }
    }
}
</style>
<style scoped>
#top-rail #mobile-menu .router-link-exact-active {
    color: var(--color-secondary-500);
}
</style>
